import { Link, useLoaderData, data } from "react-router";
import { companiesByState } from "~/data/.server/business";
import stateConverter from "us-state-converter";
import { capitalizeName } from "~/lib/utils";
import { USAMap } from "@mirawision/usa-map-react";

import type { LoaderFunctionArgs } from "react-router";

export const loader = async ({ context }: LoaderFunctionArgs) => {
  const db = context.cloudflare.env.DB;
  const states = await companiesByState(db, 5);
  return data(
    { states },
    { headers: { "Cache-Control": "public, s-maxage=60" } },
  );
};

export function USMap({ states }: { states: string[] }) {
  return (
    <div className="px-4 py-2 pb-4">
      <USAMap
        mapSettings={{ height: "fit-content" }}
        className="max-w-screen min-h-[200px] md:min-h-[500px]"
        customStates={Object.fromEntries(
          states.map((state) => [
            state,
            {
              fill: "#f0f0f0",
              onClick: (state) => {
                const targetElement = document.querySelector("#" + state);
                if (
                  targetElement &&
                  targetElement instanceof HTMLDetailsElement
                ) {
                  for (const el of document.querySelectorAll("details")) {
                    if (el instanceof HTMLDetailsElement) {
                      el.open = false;
                    }
                  }
                  targetElement.open = !targetElement.open;
                  targetElement.scrollIntoView({
                    behavior: "smooth",
                    block: "start",
                  });
                }
              },
            },
          ]),
        )}
      />
    </div>
  );
}

export default function AllCompaniesPage() {
  const { states } = useLoaderData<typeof loader>();

  return (
    <div className="mx-auto max-w-screen-lg space-y-4 px-2">
      <h1 className="text-2xl font-bold">All Moving Companies</h1>
      <h2>Click on a state to find your region</h2>
      <USMap states={states.map((s) => s.state)} />
      <ul className="grid grid-cols-1 gap-4 px-4 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
        {states.map((state) => (
          <li key={state.state}>
            <details id={state.state}>
              <summary className="text-lg">
                {stateConverter.fullName(state.state)}
              </summary>
              <div className="py-2">
                {state.companies
                  .filter((c) => c.slug)
                  .map((company) => (
                    <div key={company.dot}>
                      <Link
                        className="block border-b py-2 hover:bg-muted"
                        to={`/state/${state.state.toLowerCase()}/business/${company.slug}`}
                      >
                        {capitalizeName(company.name ?? "")}
                      </Link>
                    </div>
                  ))}
                <Link
                  className="block py-2 font-semibold hover:bg-muted"
                  to={`/state/${state.state.toLowerCase()}`}
                >
                  More...
                </Link>
              </div>
            </details>
          </li>
        ))}
      </ul>
    </div>
  );
}
